import { useAuthContext } from "@covertree/auth";

import { CognitoUserGroup } from "@enums/CognitoUserGroup";

interface RenderProps {
  canSeePortfolioList: boolean;
}

interface AccessPatternProviderProps {
  children: React.ReactNode | ((props: RenderProps) => React.ReactNode);
}

const AccessPatternProvider = ({ children }: AccessPatternProviderProps) => {
  const { hasGroup } = useAuthContext();

  return typeof children === "function"
    ? children({
        canSeePortfolioList: hasGroup(CognitoUserGroup.CoverTreeExecutive),
      })
    : children;
};

export default AccessPatternProvider;
